import React, { useState } from "react";
import styles from "./ActiveVkContainer.module.scss";
import { useDispatch, useSelector } from "react-redux";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { AllChatsContainer } from "../AllChatsContainer/AllChatsContainer";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { AllInfoVkContainer } from "./components/AllInfoVkContainer/AllInfoVkContainer";
import { setUpdateVk } from "../../store/slices/vkSlice";
import {
  configureVkClient,
  getVkIntegration,
} from "../../utils/api/actions/integrations/vk";

export const ActiveVkContainer = () => {
  const dispatch = useDispatch();

  const { activeVk, updateVk, updateVkData, isErrorVk } = useSelector(
    (state) => state?.vk
  );

  const [isLoadingVk, setIsLoadingVk] = useState(false);
  const [activeNav, setActiveNav] = useState("all info");

  const errorEmptyAssistantId = () =>
    toast.error("Выберите ассистента!", {
      toastId: "customId",
    });

  const navItems = [
    {
      name: "Общая информация",
      value: "all info",
      component: <AllInfoVkContainer />,
    },
    {
      name: "Чаты",
      value: "chats",
      component: <AllChatsContainer />,
    },
  ];

  const valueObserver = (e) => {
    e.stopPropagation();
    setActiveNav(e.target.id);

    dispatch(
      getVkIntegration(activeVk.userId, activeVk.groupId, setIsLoadingVk)
    );
  };

  const renderNavItems = (arr) => {
    return arr.map((el, index) => {
      return (
        <div
          key={`vk-${index}`}
          className={
            el.value === activeNav ? styles.activeNavItem : styles.navItem
          }
          id={el.value}
          onClick={valueObserver}
        >
          {el.name}
        </div>
      );
    });
  };

  const renderBodyItems = (arr) => {
    return arr
      .map((item, index) => {
        if (item.value === activeNav) {
          return <div key={item.value}>{item.component}</div>;
        }
        return null; // Возвращаем null, если условие не выполняется
      })
      .filter(Boolean); // Фильтруем null значения, если нужно
  };

  const onCancelEdit = () => {
    dispatch(setUpdateVk(false));
  };

  const onSaveUpdatedData = () => {
    if (
      updateVkData.assistantId &&
      updateVkData.assistantId !== "00000000-0000-0000-0000-000000000000"
    ) {
      dispatch(configureVkClient(updateVkData));
    } else {
      errorEmptyAssistantId();
    }
  };

  return (
    <div className={styles.container}>
      <ScreenHeader
        onCancelEdit={onCancelEdit}
        onSaveUpdatedData={onSaveUpdatedData}
        isEditing={updateVk}
        title={"Интеграции"}
        path={"/integration"}
      />
      {isLoadingVk ? (
        <div className={styles.loaderContainer}>
          <ClipLoader color="#3e8fcb" size={90} />
          <div>Загрузка данных</div>
        </div>
      ) : (
        <>
          <div className={styles.navContainer}>{renderNavItems(navItems)}</div>
          <div
            className={styles.body}
            style={{
              height: isErrorVk && "calc(80% - 40px)",
              justifyContent: isErrorVk && "center",
            }}
          >
            {renderBodyItems(navItems)}
          </div>
        </>
      )}
    </div>
  );
};
